// Shown when an agent saves an outcome on a customer someone else owns (one owner per
// customer, Sep 2026): the outcome is kept on the timeline, the owner's stays.
export const interactionNotice = (ownerName?: string | null): string =>
    `Saved on the customer's timeline. ${ownerName || 'Another agent'} owns this customer, ` +
    `so their outcome stays and they've been told.`;
